import { render, staticRenderFns } from "./FlowCurrentTime.vue?vue&type=template&id=38ce378a&"
import script from "./FlowCurrentTime.vue?vue&type=script&lang=js&"
export * from "./FlowCurrentTime.vue?vue&type=script&lang=js&"
import style0 from "./FlowCurrentTime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports